import { createContext } from 'react';
import { ICategoryPositionItem } from 'types';

export type TChangeCategoryPositionSelectedItem = Nullable<string>;
export type TChangeCategoryPositionSelectedRestaurant = { id: string; name: string };
export type TTypeOfChangeCategoryPositionModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSave'
	| 'success'
	| 'error';

export interface IChangeCategoryPositionState {
	IDSelectedCustomer: TChangeCategoryPositionSelectedItem;
	selectedRestaurant: TChangeCategoryPositionSelectedRestaurant | null;
	positionsData: ICategoryPositionItem[];
	typeOfModalWindow: TTypeOfChangeCategoryPositionModalWindow;
	isVisibleAdditionalRestaurantsModal: boolean;
	isApplyToOne: boolean;
	selectedAdditionalRestaurants: TChangeCategoryPositionSelectedRestaurant[];
	selectSearchString: string;
}

export const changeCategoryPositionInitialState: IChangeCategoryPositionState = {
	IDSelectedCustomer: null,
	selectedRestaurant: null,
	positionsData: [],
	typeOfModalWindow: null,
	isVisibleAdditionalRestaurantsModal: false,
	isApplyToOne: false,
	selectedAdditionalRestaurants: [],
	selectSearchString: '',
};

export interface IChangeCategoryPositionContext extends IChangeCategoryPositionState {
	setIDCustomer(value: TChangeCategoryPositionSelectedItem): void;
	setRestaurant(value: TChangeCategoryPositionSelectedRestaurant | null): void;
	resetSelectedControls(): void;
	setPositionsData(data: ICategoryPositionItem[]): void;
	reorderItems(value: ICategoryPositionItem[]): void;
	changeTypeOfModalWindow(value: TTypeOfChangeCategoryPositionModalWindow): void;
	setVisibleAdditionalRestaurantsModal(value: boolean): void;
	toggleApplyToOne(): void;
	setAdditionalRestaurants(value: TChangeCategoryPositionSelectedRestaurant[]): void;
	changeSelectSearchString(value: string): void;
}

export const ChangeCategoryPositionContext = createContext<IChangeCategoryPositionContext>({
	setIDCustomer: () => undefined,
	setRestaurant: () => undefined,
	resetSelectedControls: () => undefined,
	setPositionsData: () => undefined,
	reorderItems: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setVisibleAdditionalRestaurantsModal: () => undefined,
	toggleApplyToOne: () => undefined,
	setAdditionalRestaurants: () => undefined,
	changeSelectSearchString: () => undefined,
	...changeCategoryPositionInitialState,
});
